import React from 'react';
import PropTypes from 'prop-types';

const InputInsideLabel = (props) => {
  const { classNames } = props;

  const onEvent = (e) => {
    const initialEventType = e.type;


    if (e.target.value === '') {
      e.target.removeAttribute('notempty');
      /* firefox and IE hack because general sibling selector " ~ label" does not work */
      e.target.nextSibling.removeAttribute('notempty');
    } else {
      e.target.setAttribute('notempty', '');
      /* firefox and IE hack because general sibling selector " ~ label" does not work */
      e.target.nextSibling.setAttribute('notempty', '');
    }
    props.onChange(e);

    /* firefox and IE hack because general sibling selector " ~ label" does not work */
    if (initialEventType === 'focus') {
      e.target.nextSibling.setAttribute('notempty', '');
    } else if (e.target.value === '') {
      e.target.nextSibling.removeAttribute('notempty');
    }
  };

  return (
    <div className={`inputInsideLabel ${classNames.join(' ')}`}>
      <input
        id={props.name}
        name={props.name}
        type={props.type}
        maxLength={props.maxlength}
        className={props.inputClassNames.join(' ')}
        value={props.value}
        autoFocus // eslint-disable-line
        onFocus={onEvent}
        onBlur={onEvent}
        onChange={onEvent}
      />
      <label htmlFor={props.name}>{props.label}</label>
    </div>
  );
};

InputInsideLabel.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  classNames: PropTypes.instanceOf(Array),
  inputClassNames: PropTypes.instanceOf(Array),
  maxlength: PropTypes.number,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};
InputInsideLabel.defaultProps = {
  classNames: [],
  inputClassNames: [],
  maxlength: 524288,
  type: 'text',
  value: '',
  onChange: () => {},
};

export default InputInsideLabel;
